import { NgProviderHelper } from "@/helpers";

const broadcastNgLocationChange = () => {
  // For some reason `notifyNgUrlChangeHook()` is running too late (after digest)
  // when navigating using brower's forward/back buttons. Wrapping digest in
  // a setTimeout seems to correct the order.
  setTimeout(() => {
    const $rootScope = NgProviderHelper.getInstance("$rootScope");
    $rootScope.$digest();

    // Dirty hack to make article's inline modals open on page load/refresh by
    // manually triggering `modalHandler`s `eventHandler` in `app.run.js`
    $rootScope.$broadcast("$locationChangeSuccess");
  });
};

export const compileNgTemplate = (el: HTMLElement, shouldBroadcast: boolean) => {
  const $rootScope = NgProviderHelper.getInstance("$rootScope");
  const $compile = NgProviderHelper.getInstance("$compile");

  $compile(el)($rootScope);

  // Used to ensure Ng broadcast hack is only called once, used when there are multiple articles.
  if (shouldBroadcast) {
    broadcastNgLocationChange();
  }
};
